<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onAddSave" v-acl="RMC_PROT_FARM_SAVE" v-if="rmcProteinFarmId==='0'&&(!detailForm.auditStatus||detailForm.auditStatus==='Draft')&&(ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1)">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onEditSave" v-acl="RMC_PROT_FARM_SAVE" v-if="rmcProteinFarmId!=='0'&&(!detailForm.auditStatus||detailForm.auditStatus==='Draft')&&(ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1)">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-acl="RMC_PROT_FARM_SUBMIT" v-if="detailForm.auditStatus!=='PendingApproval'&&(ms_roles.indexOf('QSPI_RMC_CHICK_SPONS_SUPP')!==-1||ms_roles.indexOf('QSPI_RMC_PORK_SPONS_SUPP')!==-1)">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onApprove" v-acl="RMC_PROT_FARM_APPROVE" v-if="detailForm.auditStatus==='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS')!==-1">批准</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onReturn" v-acl="RMC_PROT_FARM_RETURN" v-if="detailForm.auditStatus==='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PROTEIN_CQS')!==-1">退回</el-button>
      </el-row>
      <el-form :model="detailForm" ref="detailForm" label-width="120px">
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">农场清单</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="Category3" prop="category3Code">
                  <el-select v-model="detailForm.category3Code" :disabled="isDisabled||isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Sponsor" prop="sponsorName">
                  <el-input v-model="detailForm.sponsorName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="ASL Group" prop="aslGroupCode" :rules="rules.aslGroupCode" class="is-required">
                  <el-select v-model="detailForm.aslGroupCode" clearable :disabled="isForbidden" @change="getBreedingModeByAslGroup" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in aslGroupCodeOptions" :label="item.aslGroupName" :value="item.aslGroupCode"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="auditStatus">
                  <el-select v-model="detailForm.auditStatus" disabled placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in auditStatusOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="农场" prop="farmName" :rules="rules.farmName" class="is-required">
                  <el-input v-model="detailForm.farmName" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="追溯代码" prop="traceCode" :rules="rules.traceCode">
                  <el-input v-model="detailForm.traceCode" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="地址" prop="farmAddress" :rules="rules.farmAddress" class="is-required">
                  <el-input v-model="detailForm.farmAddress" :disabled="isForbidden" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="舍数" prop="numOfHouse" :rules="rules.numOfHouse" class="is-required">
                  <el-input v-model="detailForm.numOfHouse" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="养殖量/栋(万只)" prop="breedingQuantityPerHouse" :rules="rules.breedingQuantityPerHouse" class="is-required">
                  <el-input v-model="detailForm.breedingQuantityPerHouse" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="批出栏量(万只)" prop="slaughterVolumePerBatch" :rules="rules.slaughterVolumePerBatch" class="is-required">
                  <el-input v-model="detailForm.slaughterVolumePerBatch" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="年出栏量(万只)" prop="slaughterVolumePerYear" :rules="rules.slaughterVolumePerYear" class="is-required">
                  <el-input v-model="detailForm.slaughterVolumePerYear" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="养殖场性质" prop="farmNature" :rules="rules.farmNature" class="is-required">
                  <el-select v-model="detailForm.farmNature" :disabled="isForbidden" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in farmNatureOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="养殖模式" prop="breedingMode" :rules="rules.breedingMode" class="is-required">
                  <el-select v-model="detailForm.breedingMode" :disabled="isForbidden" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in breedingModeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否有备案" prop="isInspected" :rules="rules.isInspected" class="is-required">
                  <el-select v-model="detailForm.isInspected" :disabled="isForbidden" clearable @change="isInspectedChange" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in isInspectedOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="商检局备案号" prop="inspectionNo" :class="detailForm.isInspected == 'Y'?'is-required':''" :rules="rules.inspectionNo">
                  <el-input v-model="detailForm.inspectionNo" :disabled="detailForm.isInspected=='N'||isForbidden" style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="场长" prop="farmDirector" :rules="rules.farmDirector" class="is-required">
                  <el-input v-model="detailForm.farmDirector" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系电话" prop="phoneNo" :rules="rules.phoneNo" class="is-required">
                  <el-input v-model="detailForm.phoneNo" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="农场状态" prop="farmStatus" :rules="rules.farmStatus" class="is-required">
                  <el-select v-model="detailForm.farmStatus" :disabled="isForbidden" clearable placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in farmStatusOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="$route.query.from === 'edit'">
              <el-col :span="24">
                <el-form-item label="上次修改原因" prop="lastUpdateReason">
                  <el-input v-model="lastUpdateReason" disabled type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="修改原因" prop="updateReason" class="is-required" :rules="rules.updateReason">
                  <el-input v-model="detailForm.updateReason" :disabled="isForbidden" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="退回意见" :visible.sync="dialogReturnVisible" width="30%" :close-on-click-modal="false" @close="onClose" class="fpa">
      <el-form ref="returnForm" :model="returnForm" :rules="returnFormRules">
        <el-form-item prop="returnedReason">
          <el-input v-model="returnForm.returnedReason" maxlength="1000" show-word-limit type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center">
        <el-button size="mini" @click="onConfirm" type="primary">确定</el-button>
        <el-button size="mini" @click="onClose">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import rmcProtFarmApi from "@/api/rmcProtein/farm";
export default {
  name: "rmcProtfarmNameDetail",
  components: {
    IcSelect,
  },
  data() {
    return {
      rules: {
        aslGroupCode: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择ASL Group')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        // 用户输入，不能重复
        farmName: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入农场')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“农场”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        traceCode: [
          {
            validator: (rule, value, callback) => {
              if (value) {
                var reg = /^.{0,100}$/
                if (!reg.test(value)) {
                  this.$message.error('字段“追溯代码”已超出数据库长度要求（长度：100），请删减.')
                  return callback(new Error(' '));
                }
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        farmAddress: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入地址')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“地址”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        numOfHouse: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入舍数')
                return callback(new Error(' '));
              };
              var reg = /^\d+$/
              if (!reg.test(value)) {
                this.$message.error('字段“舍数”输入格式不满足要求（格式：正整数或0），请检查.')
                return callback(new Error(' '));
              }
              var reg1 = /^.{1,10}$/
              if (!reg1.test(value)) {
                this.$message.error('字段“舍数”已超出数据库长度要求（长度：10），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        breedingQuantityPerHouse: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入养殖量/栋(万只)')
                return callback(new Error(' '));
              };
              var reg = /^[0-9]+(\.[0-9]{1,2})?$/
              if (!reg.test(value)) {
                this.$message.error('字段“养殖量/栋(万只)”输入格式不满足要求（格式：数字,最多两位小数），请检查.')
                return callback(new Error(' '));
              }
              var reg1 = /^.{1,10}$/
              if (!reg1.test(value)) {
                this.$message.error('字段“养殖量/栋(万只)”已超出数据库长度要求（长度：10），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        slaughterVolumePerBatch: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入批出栏量(万只)')
                return callback(new Error(' '));
              };
              var reg = /^[0-9]+(\.[0-9]{1,2})?$/
              if (!reg.test(value)) {
                this.$message.error('字段“批出栏量(万只)”输入格式不满足要求（格式：数字,最多两位小数），请检查.')
                return callback(new Error(' '));
              }
              var reg1 = /^.{1,10}$/
              if (!reg1.test(value)) {
                this.$message.error('字段“批出栏量(万只)”已超出数据库长度要求（长度：10），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        slaughterVolumePerYear: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入年出栏量(万只)')
                return callback(new Error(' '));
              };
              var reg = /^[0-9]+(\.[0-9]{1,2})?$/
              if (!reg.test(value)) {
                this.$message.error('字段“年出栏量(万只)”输入格式不满足要求（格式：数字,最多两位小数），请检查.')
                return callback(new Error(' '));
              }
              var reg1 = /^.{1,10}$/
              if (!reg1.test(value)) {
                this.$message.error('字段“年出栏量(万只)”已超出数据库长度要求（长度：10），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        farmNature: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择养殖场性质')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        breedingMode: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择养殖模式')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        isInspected: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择是否有备案')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        // 当是否有备案为否时，默认置灰，不校验必填。当是否有备案为是时，可输入，校验必填；
        inspectionNo: [
          {
            validator: (rule, value, callback) => {
              if (this.detailForm.isInspected == 'Y' && !value) {
                this.$message.error('请输入商检局备案号')
                return callback(new Error(' '));
              };
              if (value) {
                var reg = /^.{1,100}$/
                if (!reg.test(value)) {
                  this.$message.error('字段“商检局备案号”已超出数据库长度要求（长度：100），请删减.')
                  return callback(new Error(' '));
                }
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        farmDirector: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入场长')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“场长”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        phoneNo: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入联系电话')
                return callback(new Error(' '));
              };
              var reg = /^.{1,100}$/
              if (!reg.test(value)) {
                this.$message.error('字段“联系电话”已超出数据库长度要求（长度：100），请删减.')
                return callback(new Error(' '));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        farmStatus: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请选择农场状态')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "change"
          }
        ],
        // 新建时，不校验必填，审核通过以后再维护时校验必填
        updateReason: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error('请输入修改原因')
                return callback(new Error(' '));
              };
              callback();
            },
            trigger: "blur"
          }
        ],
      },
      detailForm: {},
      returnForm: {
        returnedReason: "",
      },
      returnFormRules: {
        returnedReason: [
          { required: true, message: '请输入退回意见', trigger: 'blur' },
        ],
      },
      tableData: [],
      fileList: [],
      category3CodeOptions: [],
      farmNatureOptions: [],
      isInspectedOptions: [
        {
          object: "Y",
          key: "Y"
        },
        {
          object: "N",
          key: "N"
        }
      ],
      breedingModeOptions: [],
      farmStatusOptions: [],
      auditStatusOptions: [],
      aslGroupCodeOptions: [],
      rmcProteinFarmIds: [],
      isDisabled: true,
      isForbidden: false,
      dialogReturnVisible: false,
      ms_roles: null,
      ms_Permission: null,
      rmcProteinFarmId: "",
      lastUpdateReason:"",
    }
  },
  async created() {
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    this.rmcProteinFarmId = this.$route.query.rmcProteinFarmId
    await this.getSelection();
    if (this.$route.query.from === 'edit') {
      if (this.$route.query.rmcProteinFarmId) {
        this.rmcProteinFarmIds.push(this.$route.query.rmcProteinFarmId)
      }
      this.getDetailInfo()
    } else {
      this.$set(this.detailForm, 'auditStatus', 'Draft')
      this.getSponsorByUser()
      this.getAuthorizedCategory3()
    }
  },
  mounted() {

  },
  methods: {
    // 根据ASL group获取养殖模式
    getBreedingModeByAslGroup(aslGroupCode) {
      rmcProtFarmApi.getBreedingModeByAslGroup({category3Code: this.detailForm.category3Code, aslGroupCode: aslGroupCode}).then(res => {
        this.breedingModeOptions = res?res:[];
        if(this.detailForm.breedingMode) {
          this.$set(this.detailForm, "breedingMode", "");
        }
      })
    },
    getDetailInfo() {
      rmcProtFarmApi.getFarmDetail(this.$route.query.rmcProteinFarmId).then(res => {
        console.log('获取农场明细', res);
        this.detailForm = res.data
        this.rmcProteinFarmId = res.data.rmcProteinFarmId
        this.lastUpdateReason=res.data.updateReason
        this.detailForm.updateReason=""
        if (res.data.auditStatus !== 'PendingApproval' && (this.ms_Permission.indexOf('RMC_PROT_FARM_SAVE') !== -1 || this.ms_Permission.indexOf('RMC_PROT_FARM_SUBMIT') !== -1)) {
          this.isForbidden = false
        } else {
          this.isForbidden = true
        }
        this.getAslGroupList(res.data.sponsorCode, res.data.aslGroupCode);
        if(res.data.aslGroupCode) {
          rmcProtFarmApi.getBreedingModeByAslGroup({category3Code: this.detailForm.category3Code, aslGroupCode: res.data.aslGroupCode}).then(res => {
            this.breedingModeOptions = res?res:[];
          })
        }
      });
    },
    getSponsorByUser() {
      rmcProtFarmApi.getSponsorByUser().then(res => {
        console.log('获取Sponsor', res);
        this.detailForm.sponsorName = res.data.supplierName
        this.detailForm.sponsorCode = res.data.supplierCode
        if (this.$route.query.from === 'add') {
          this.getAslGroupList(res.data.supplierCode);
        }
      });
    },
    getAuthorizedCategory3() {
      rmcProtFarmApi.getAuthorizedCategory3(this.$route.query.rmcProteinFarmId).then(res => {
        console.log('获取category3', res);
        this.category3CodeOptions = res.data.filter((v) => {
          return v.cascadeKey === 'protein'
        })
        if (this.category3CodeOptions.length === 1) {
          this.detailForm.category3Code = this.category3CodeOptions[0].key
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      });
    },
    async getSelection() {
      let res = await rmcProtFarmApi.getSelection(['rmc.RmcCategory3', 'rmc.RmcFarmBreedingMode', 'rmc.RmcFarmNature', 'rmc.RmcProteinFarmStatus', 'rmc.RmcAuditStatus']);
      this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
        return v.cascadeKey === 'protein'
      })
      this.farmNatureOptions = res.data['rmc.RmcFarmNature'];
      this.breedingModeOptions = res.data['rmc.RmcFarmBreedingMode'];
      this.farmStatusOptions = res.data['rmc.RmcProteinFarmStatus'];
      this.auditStatusOptions = res.data['rmc.RmcAuditStatus'];
    },
    getAslGroupList(sponsor, aslGroupCode) {
      rmcProtFarmApi.getAslGroupList(sponsor).then(res => {
        console.log('获取ASL Group', res);
        this.aslGroupCodeOptions = res.data
        var codeLists = res.data.map(ele => {
          return ele.aslGroupCode
        })
        console.log('codeLists', codeLists);
        if (aslGroupCode&&!codeLists.includes(aslGroupCode)) {
          this.aslGroupCodeOptions.push({
            aslGroupCode: this.detailForm.aslGroupCode,
            aslGroupName: this.detailForm.aslGroupName,
            enabled: false,
            sponsorCode: sponsor,
          })
        }
        console.log('this.aslGroupCodeOptions', this.aslGroupCodeOptions);
      });
    },
    isInspectedChange(val) {
      if (val == 'N' && this.detailForm.inspectionNo) {
        this.detailForm.inspectionNo = ''
      }
    },
    onAddSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            aslGroupCode: this.detailForm.aslGroupCode,
            farmName: this.detailForm.farmName,
            traceCode: this.detailForm.traceCode,
            farmAddress: this.detailForm.farmAddress,
            numOfHouse: this.detailForm.numOfHouse,
            breedingQuantityPerHouse: this.detailForm.breedingQuantityPerHouse,
            slaughterVolumePerBatch: this.detailForm.slaughterVolumePerBatch,
            slaughterVolumePerYear: this.detailForm.slaughterVolumePerYear,
            farmNature: this.detailForm.farmNature,
            breedingMode: this.detailForm.breedingMode,
            isInspected: this.detailForm.isInspected,
            inspectionNo: this.detailForm.inspectionNo,
            farmDirector: this.detailForm.farmDirector,
            phoneNo: this.detailForm.phoneNo,
            farmStatus: this.detailForm.farmStatus,
            updateReason: this.detailForm.updateReason
          }
          rmcProtFarmApi.addFarm(obj).then(res => {
            console.log('保存', res);
            if (res.meta.code === 200) {
              this.$message.success('保存成功')
              this.$router.push('/rmcProtFarm')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onEditSave() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            aslGroupCode: this.detailForm.aslGroupCode,
            farmName: this.detailForm.farmName,
            traceCode: this.detailForm.traceCode,
            farmAddress: this.detailForm.farmAddress,
            numOfHouse: this.detailForm.numOfHouse,
            breedingQuantityPerHouse: this.detailForm.breedingQuantityPerHouse,
            slaughterVolumePerBatch: this.detailForm.slaughterVolumePerBatch,
            slaughterVolumePerYear: this.detailForm.slaughterVolumePerYear,
            farmNature: this.detailForm.farmNature,
            breedingMode: this.detailForm.breedingMode,
            isInspected: this.detailForm.isInspected,
            inspectionNo: this.detailForm.inspectionNo,
            farmDirector: this.detailForm.farmDirector,
            phoneNo: this.detailForm.phoneNo,
            farmStatus: this.detailForm.farmStatus,
            updateReason: this.detailForm.updateReason
          }
          rmcProtFarmApi.updateFarm(this.rmcProteinFarmId, obj).then(res => {
            console.log('更新', res);
            if (res.meta.code === 200) {
              this.$message.success('保存成功')
              this.$router.push('/rmcProtFarm')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onSubmit() {
      this.$refs['detailForm'].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            aslGroupCode: this.detailForm.aslGroupCode,
            farmName: this.detailForm.farmName,
            traceCode: this.detailForm.traceCode,
            farmAddress: this.detailForm.farmAddress,
            numOfHouse: this.detailForm.numOfHouse,
            breedingQuantityPerHouse: this.detailForm.breedingQuantityPerHouse,
            slaughterVolumePerBatch: this.detailForm.slaughterVolumePerBatch,
            slaughterVolumePerYear: this.detailForm.slaughterVolumePerYear,
            farmNature: this.detailForm.farmNature,
            breedingMode: this.detailForm.breedingMode,
            isInspected: this.detailForm.isInspected,
            inspectionNo: this.detailForm.inspectionNo,
            farmDirector: this.detailForm.farmDirector,
            phoneNo: this.detailForm.phoneNo,
            farmStatus: this.detailForm.farmStatus,
            updateReason: this.detailForm.updateReason
          }
          rmcProtFarmApi.submitFarm(this.$route.query.rmcProteinFarmId, obj).then(res => {
            if (res.meta.code === 200) {
              this.$message.success('提交成功')
              this.$router.push('/rmcProtFarm')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onApprove() {
      rmcProtFarmApi.approveFarm({
        rmcProteinFarmIds: this.rmcProteinFarmIds
      }).then(res => {
        if (res.meta.code === 200) {
          this.$message.success('批准成功')
          this.$router.push('/rmcProtFarm')
        } else {
          this.$message.error(res.meta.msg)
        }
      })
    },
    onReturn() {
      this.dialogReturnVisible = true
    },
    onConfirm() {
      this.$refs['returnForm'].validate((valid) => {
        if (valid) {
          rmcProtFarmApi.returnFarm({
            rmcProteinFarmIds: this.rmcProteinFarmIds,
            returnedReason: this.returnForm.returnedReason
          }).then(res => {
            if (res.meta.code === 200) {
              this.$message.success('退回成功')
              this.onClose()
              this.$router.push('/rmcProtFarm')
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onClose() {
      this.dialogReturnVisible = false
      this.returnForm.returnedReason = ''
    },
    routerBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style>
</style>